import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import tagGroup from './tagGroup.vue';
export default {
  components: {
    tagGroup
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  watch: {
    data: {
      handler(newV) {
        this.tagsData = newV;
      },
      deep: true
    }
  },
  data() {
    return {
      tagsData: []
    };
  },
  created() {
    this.tagsData = this.$props.data;
  },
  methods: {
    onChangeTags(data, index) {
      if (data.length) {
        if (data.length === this.tagsData[index].children.length) {
          this.tagsData[index].checkAll = true;
          this.tagsData[index].indeterminate = false;
        } else {
          this.tagsData[index].indeterminate = true;
          this.tagsData[index].checkAll = false;
        }
      } else {
        this.tagsData[index].checkAll = false;
        this.tagsData[index].indeterminate = false;
      }
      this.$emit('onChange');
    },
    onCheckAllChange(e, index) {
      this.tagsData[index].children.map(item => {
        if (e.target.checked) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
      this.tagsData[index].checkAll = e.target.checked;
      this.tagsData[index].indeterminate = false;
      // let data = [];
      // this.tagsData[index].children.map(item =>
      //   item.checked ? data.push({fieldName: item.fieldName, fieldValue: item.fieldValue}) : null
      // );
      this.$emit('onChange');
    }
  }
};